import { render } from "./document-attachment.vue?vue&type=template&id=73673917"
import script from "./document-attachment.vue?vue&type=script&lang=js"
export * from "./document-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__